"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/* Captured From PROD at http://localhost:3000/en/cars */
var DEFAULT_PROPS = [{
  type: 'large',
  data: {
    id: 'language-masters_en_1543348838519',
    resourceType: 'EditorialCards_1_0_0',
    lastModified: '1543348838519',
    editorialLayout: 'large',
    columns: [{
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/asx.jpg',
        __typename: 'Image'
      },
      price: {
        displayValue: 'From ###,###.##',
        __typename: 'Price'
      },
      tag: {
        label: 'Offer',
        __typename: 'Tag'
      },
      overlayImage: null,
      specifications: [{
        image: {
          image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/icons/vehicle-specs/fuel.svg',
          __typename: 'Image'
        },
        label: 'Unleaded',
        __typename: 'Option'
      }, {
        image: {
          image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/icons/vehicle-specs/seat.svg',
          __typename: 'Image'
        },
        label: '5 Seats',
        __typename: 'Option'
      }],
      description: {
        textAlignment: 'left',
        sectionHeading: 'ASX',
        mainHeading: null,
        paragraph: 'Our compact SUV is both practical and economical, so it fits every aspect of your life and your budget.',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en/cars/asx',
        label: 'Explore',
        priority: 'medium',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }, {
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/outlander_phev.jpg',
        __typename: 'Image'
      },
      price: {
        displayValue: 'From ###,###.##',
        __typename: 'Price'
      },
      tag: {
        label: 'Offer',
        __typename: 'Tag'
      },
      overlayImage: null,
      specifications: [{
        image: {
          image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/icons/vehicle-specs/fuel.svg',
          __typename: 'Image'
        },
        label: 'Unleaded',
        __typename: 'Option'
      }, {
        image: {
          image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/icons/vehicle-specs/seat.svg',
          __typename: 'Image'
        },
        label: '5 Seats',
        __typename: 'Option'
      }],
      description: {
        textAlignment: 'left',
        sectionHeading: 'OUTLANDER PHEV',
        mainHeading: null,
        paragraph: "The world's bestselling PHEV SUV will reduce your running costs and has superb off-road credentials.",
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en/cars/outlander-phev',
        label: 'Explore',
        priority: 'medium',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }],
    __typename: 'Editorial'
  }
}, {
  type: 'high-low',
  data: {
    id: 'language-masters_en_1542135259419',
    resourceType: 'EditorialCards_1_0_0',
    lastModified: '1542135259419',
    editorialLayout: 'highlow',
    columns: [{
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/asx_high_low_stop_and_go.jpg',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: 'Auto Stop & Go System (AS&G)',
        mainHeading: 'Reduce fuel waste and emissions',
        paragraph: 'The Auto Stop & Go System (AS&G) shuts off the engine at traffic stops, cutting fuel waste and CO2 emissions without disrupting the electronic systems. The engine restarts immediately, so you’ll never be left waiting.',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '',
        label: '',
        priority: null,
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }, {
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/asx_high_low_keyless_entry.jpg',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: 'Keyless Entry',
        mainHeading: 'Open the car by standing next to it',
        paragraph: 'Keep your keys securely hidden in your pocket or handbag. Unlock and start the car just by having the keys nearby.',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '',
        label: '',
        priority: null,
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }],
    __typename: 'Editorial'
  }
}, {
  type: 'medium',
  data: {
    id: 'language-masters_en_1552921650141',
    resourceType: 'EditorialCards_1_0_0',
    lastModified: '1552921650141',
    editorialLayout: 'medium',
    columns: [{
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/Fleet_Medium_Mirage_720x540.png',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: '£700 deposit contribution',
        mainHeading: 'Mirage Inform',
        paragraph: "A compact runabout that's economical to run and easy to park.",
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en/buy/offers/business',
        label: 'View offer',
        priority: 'medium',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }, {
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/Fleet_Medium_ASX_720x540.png',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: '3 years 0% APR and no deposit',
        mainHeading: 'ASX Invite',
        paragraph: 'Our compact SUV is both practical and economical.',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en/buy/offers/business',
        label: 'View offer',
        priority: 'medium',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }, {
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/Fleet_Medium_Eclipse_720x540.png',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: '£1,500 deposit contribution',
        mainHeading: 'Eclipse Cross Intense',
        paragraph: 'Our mid-sized, sporty SUV has category-defining looks that make a bold statement.',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en/buy/offers/business',
        label: 'View offer',
        priority: 'medium',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }],
    __typename: 'Editorial'
  }
}, {
  type: 'xl',
  data: {
    id: 'language-masters_en_1550175464275',
    resourceType: 'EditorialCards_1_0_0',
    lastModified: '1550175464275',
    editorialLayout: 'extralarge',
    columns: [{
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/editorial-xl-cards-image-1.png',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: null,
        mainHeading: 'Join our Head Office team',
        paragraph: 'Start your career with us in our Cirencester head office, achieve your ambitions by taking advantage of the Mitsubishi Training Academy and excel in your career.\r\n',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en',
        label: 'Learn More',
        priority: 'low',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }, {
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/editorial-xl-cards-image-2.png',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: null,
        mainHeading: 'Work in one of our dealerships',
        paragraph: 'We’re offering the best career prospects in the motor industry. Join our teamon the front line, delivering quality cars and a remarkable service to drivers across the world.\r\n',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en',
        label: 'Learn More',
        priority: 'low',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }],
    __typename: 'Editorial'
  }
}, {
  type: 'content-grid',
  data: {
    id: 'language-masters_en_1550772238020',
    resourceType: 'EditorialCards_1_0_0',
    lastModified: '1550772238020',
    editorialLayout: 'contentgrid',
    columns: [{
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/electric-charging.jpg',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: 'ELECTRIC AND POWER ',
        mainHeading: 'Charging your Outlander PHEV',
        paragraph: 'From charging points to connector types, this video gives you all the information you need on charging your PHEV. ',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en',
        label: 'Learn More',
        priority: 'low',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }, {
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/bonnet.jpg',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: 'UNDER THE BONNET ',
        mainHeading: 'Learn under the bonnet basics',
        paragraph: 'The most important (and luckily one of the easiest) ways to look after your car is by checking fluid levels. ',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en',
        label: 'Learn More',
        priority: 'low',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }, {
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/lifestyle.jpg',
        __typename: 'Image'
      },
      price: null,
      tag: null,
      overlayImage: null,
      specifications: null,
      description: {
        textAlignment: 'left',
        sectionHeading: 'LIFESTYLE',
        mainHeading: 'Getting the most from your PHEV',
        paragraph: 'Keep your battery power going longer, learn about regenerative braking, ECO mode and more in this video.',
        legal: null,
        __typename: 'TextSectionBlock'
      },
      selectButton: null,
      link: {
        url: '/en',
        label: 'Learn More',
        priority: 'low',
        openNewTab: false,
        ctaType: null,
        icon: null,
        __typename: 'NavLink'
      },
      selectStyle: null,
      downloadPDFText: null,
      downloadPDFIcon: null,
      __typename: 'EditorialColumn'
    }],
    __typename: 'Editorial'
  }
}];
var _default = DEFAULT_PROPS;
exports["default"] = _default;